"use strict";

exports.__esModule = true;
exports.StripeChartCanvas = void 0;
var _react = _interopRequireWildcard(require("react"));
var _invariant = _interopRequireDefault(require("invariant"));
var _vimanaTypes = require("@vimana/vimana-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var LABEL_FONT_SIZE = 12;

/**
 * A canvas based stripe chart.
 * Does not include an axis or any other functionality.
 */
// eslint-disable-next-line no-shadow
var StripeChartCanvas = exports.StripeChartCanvas = /*#__PURE__*/function (_Component) {
  function StripeChartCanvas() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.registerCanvas = function (canvas) {
      _this.canvas = canvas;
    };
    _this.handleClick = function (e) {
      var _this$props = _this.props,
        scale = _this$props.scale,
        timeline = _this$props.timeline,
        onItemClick = _this$props.onItemClick;
      if (typeof onItemClick !== "function") {
        return;
      }
      var target = e.target;
      var rect = target.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var value = scale.invert(x);
      for (var _iterator = _createForOfIteratorHelperLoose(timeline), _step; !(_step = _iterator()).done;) {
        var item = _step.value;
        var interval = item.interval;
        if (value >= interval.startMillis && value <= interval.endMillis) {
          onItemClick(item);
          return;
        }
      }
    };
    return _this;
  }
  _inheritsLoose(StripeChartCanvas, _Component);
  var _proto = StripeChartCanvas.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var canvas = this.canvas;
    (0, _invariant["default"])(canvas, "Canvas must be present");
    this.draw(canvas);
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    var canvas = this.canvas;
    if (canvas) {
      this.draw(canvas);
    }
  };
  _proto.draw = function draw(canvas) {
    var context = canvas.getContext("2d");
    if (!context) {
      return;
    }
    var _this$props2 = this.props,
      timeline = _this$props2.timeline,
      width = _this$props2.width,
      height = _this$props2.height;
    var PIXEL_RATIO = window.devicePixelRatio || 1;

    // scale for PIXEL_RATIO

    var scaledWidth = width * PIXEL_RATIO;
    var scaledHeight = height * PIXEL_RATIO;
    canvas.width = scaledWidth;
    canvas.height = scaledHeight;

    // reset transform and set scale for the PIXEL_RATIO
    context.setTransform(PIXEL_RATIO, 0, 0, PIXEL_RATIO, 0, 0);
    context.clearRect(0, 0, scaledWidth, scaledHeight);
    var now = Date.now();
    for (var i = 0; i < timeline.length; i++) {
      var item = timeline[i];
      this.drawValue(context, item, now);
    }
  };
  _proto.drawValue = function drawValue(context, value, now) {
    var _this$props3 = this.props,
      height = _this$props3.height,
      getColor = _this$props3.getColor,
      getLabelColor = _this$props3.getLabelColor,
      getCategoryColor = _this$props3.getCategoryColor,
      categoryHeight = _this$props3.categoryHeight,
      getAlpha = _this$props3.getAlpha,
      getLabel = _this$props3.getLabel,
      scale = _this$props3.scale,
      showDivision = _this$props3.showDivision;
    var start = scale(value.interval.startMillis);
    var end = scale(value.interval.endMillis === _vimanaTypes.END_OF_TIME ? now : value.interval.endMillis);
    var width = end - start;
    if (typeof getAlpha === "function") {
      context.globalAlpha = getAlpha(value);
    }
    context.fillStyle = getColor(value);
    context.fillRect(start, 10, width, height);
    // fill border
    if (showDivision) {
      context.fillStyle = "#000";
      context.fillRect(start, 10, 1, height);
      context.fillRect(start + width, 10, 1, height);
    }
    if (getLabel) {
      var label = getLabel(value);
      if (label) {
        context.font = LABEL_FONT_SIZE + "px sans-serif";
        context.fillStyle = typeof getLabelColor === "function" ? getLabelColor(value) : "black";
        var size = context.measureText(label);
        var textWidth = Math.round(size.width);
        if (textWidth < width) {
          var labelX = Math.round(width / 2 - textWidth / 2);
          var labelY = Math.round(height / 2 + LABEL_FONT_SIZE / 2);
          context.fillText(label, start + labelX, labelY, width);
        }
      }
    }
    if (typeof getCategoryColor === "function" && categoryHeight > 0) {
      context.fillStyle = getCategoryColor(value);
      context.fillRect(start, height - categoryHeight, width, categoryHeight);
    }
  };
  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("canvas", {
      "data-getlabel": this.props.getLabel != null,
      "data-division": this.props.showDivision,
      "data-testid": "StripeChartCanvas",
      "data-timelineValue": JSON.stringify(this.props.timeline),
      ref: this.registerCanvas,
      height: this.props.height,
      width: this.props.width,
      onClick: this.handleClick,
      style: {
        width: "100%",
        height: "100%"
      }
    });
  };
  return StripeChartCanvas;
}(_react.Component);
StripeChartCanvas.defaultProps = {
  categoryHeight: 20
};